<script lang="ts">
	import { format } from 'svelte-i18n';
	import { capFirstChar } from 'src/helpers/utilities';
	//Design system components
	import { ControlsContainer, LabelListV2, Text } from '@Shelly/shelly-design-system';
	//Components
	import ThermostatTemperatureWheel from 'src/components/XT1/Thermostat/ThermostatTemperatureWheel.svelte';
	import ThermostatMode_ST802V2 from './ThermostatMode_ST802V2.svelte';
	import DeviceNotificationLabel from 'src/components/Sidepanel/DeviceNotificationLabel.svelte';
	import VirtualBooleanButton from 'src/components/DevicesSettings/VirtualComponents/Components/VirtualBooleanButton.svelte';
	//Types
	import type { Device } from 'src/types/Device';
	import type { VCInterfaceStatus } from 'src/types/VirtualComponents';
	import DeviceLabelList from 'src/components/Sidepanel/DeviceViews/DeviceLabelList.svelte';

	export let device: Device, statuses: VCInterfaceStatus[];

	let mode: string;
	const _device = device;

	$: enable = statuses.find((i) => /^(enabled?|state)$/.test(i.role));
	$: filteredStatuses = statuses.filter(
		(i) =>
			new RegExp(
				`^(heater_relay_status|${mode == 'dry' ? 'current_temperature' : 'humidity|current_humidity'})$`,
			).test(i.role) || i?.sensor,
	);
</script>

<DeviceLabelList labelList={filteredStatuses} />
<DeviceNotificationLabel deviceId={device?.id} />
<div class="flex-full-height justify-content-end">
	{#if enable?.serviceType === 'linkedgo-st-802-hvac'}
		<ThermostatMode_ST802V2 {device} {statuses} bind:mode />
	{:else}
		<ThermostatTemperatureWheel {device} {statuses} />
	{/if}
	<ControlsContainer class="mt-s" color="color-0">
		<svelte:fragment slot="first">
			<VirtualBooleanButton
				isWide
				device={_device}
				componentID={enable?.id}
				value={enable?.event}
				useV2Components
			/>
			<Text styleType="controls-large" class="mt-s text-bold"
				>{capFirstChar(
					enable?.event
						? $format('label_action_turn_off', { default: 'turn off' })
						: $format('label_action_turn_on', { default: 'turn on' }),
				)}</Text
			>
		</svelte:fragment>
	</ControlsContainer>
</div>
